import { WelcomePage } from './WelcomePage';
import { withLayout } from '../../layout/Layout';

export default withLayout(WelcomePage);